const GET_INBOX_LOADING = 'inbox/GET_INBOX_LOADING'
const GET_INBOX_SUCCESS = 'inbox/GET_INBOX_SUCCESS'
const GET_INBOX_ERROR = 'inbox/GET_INBOX_ERROR'

const GET_INBOX_DETAIL_LOADING = 'inbox/GET_INBOX_DETAIL_LOADING'
const GET_INBOX_DETAIL_SUCCESS = 'inbox/GET_INBOX_DETAIL_SUCCESS'
const GET_INBOX_DETAIL_ERROR = 'inbox/GET_INBOX_DETAIL_ERROR'

const INBOX_FILTER_ACTIVE = 'inbox/INBOX_FILTER_ACTIVE'

const INBOX_NOTIF_BADGES_TOUR = 'inbox/INBOX_NOTIF_BADGES_TOUR'

const GET_INBOX_CATEGORY_LOADING = 'inbox/GET_INBOX_CATEGORY_LOADING'
const GET_INBOX_CATEGORY_SUCCESS = 'inbox/GET_INBOX_CATEGORY_SUCCESS'
const GET_INBOX_CATEGORY_ERROR = 'inbox/GET_INBOX_CATEGORY_ERROR'
const CHANGE_CATEGORY_ACTIVE = 'inbox/CHANGE_CATEGORY_ACTIVE'

const GET_COUNTER_INBOX_LOADING = 'inbox/GET_COUNTER_INBOX_LOADING'
const GET_COUNTER_INBOX_SUCCESS = 'inbox/GET_COUNTER_INBOX_SUCCESS'
const GET_COUNTER_INBOX_ERROR = 'inbox/GET_COUNTER_INBOX_ERROR'

export {
  GET_INBOX_LOADING,
  GET_INBOX_SUCCESS,
  GET_INBOX_ERROR,
  GET_INBOX_DETAIL_LOADING,
  GET_INBOX_DETAIL_SUCCESS,
  GET_INBOX_DETAIL_ERROR,
  INBOX_FILTER_ACTIVE,
  INBOX_NOTIF_BADGES_TOUR,
  GET_INBOX_CATEGORY_LOADING,
  GET_INBOX_CATEGORY_SUCCESS,
  GET_INBOX_CATEGORY_ERROR,
  CHANGE_CATEGORY_ACTIVE,
  GET_COUNTER_INBOX_LOADING,
  GET_COUNTER_INBOX_SUCCESS,
  GET_COUNTER_INBOX_ERROR
}
